import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PhiBannerProps {
  compact?: boolean;
}

const PhiBanner: React.FC<PhiBannerProps> = ({ compact = false }) => {
  if (compact) {
    return (
      <p className="text-xs text-amber-700" data-testid="phi-banner-compact">
        <ShieldAlert className="inline h-3 w-3 mr-1 -mt-0.5" />
        Do not include patient identifiers.{' '}
        <Link to="/phi-guidelines" className="underline hover:text-amber-900">
          PHI-Zero Policy
        </Link>
      </p>
    );
  }

  return (
    <div
      className="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-2.5"
      data-testid="phi-banner"
    >
      <ShieldAlert className="h-4 w-4 text-amber-600 mt-0.5 shrink-0" />
      <div className="text-sm text-amber-800">
        <strong>PHI-Zero Policy:</strong> Do not share patient names, dates of
        birth, medical record numbers, SSNs, addresses, or any other protected
        health information.{' '}
        <Link
          to="/phi-guidelines"
          className="underline font-medium hover:text-amber-900"
          data-testid="phi-guidelines-link"
        >
          Learn more
        </Link>
      </div>
    </div>
  );
};

export default PhiBanner;
